export class CustomError {
    eventId: string;
    statusCode: number;
    errorCode: string;
    description: string;
    message: string;
    messageSize?: string;
}
